import { useTranslation } from 'react-i18next';

export default function AboutHero({ image }: { image?: string }) {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[60vh] md:min-h-[70vh] flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={image || "https://static.readdy.ai/image/3aca7b4f25b4386bcee0afd7be9c4116/8c5b39e8609a636530145738aefa79cd.png"}
          alt="Bucara Burger food truck Boise Idaho"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/90"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-black/60"></div>
      </div>

      {/* Decorative orange line */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#F57F25] to-transparent"></div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-4 md:px-6 py-24">
        {/* Eyebrow */}
        <div className="inline-flex items-center gap-2 bg-[#F57F25]/20 border border-[#F57F25]/40 text-[#F57F25] text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full mb-6">
          <span>🇨🇴</span>
          <span>{t('about_page_badge')}</span>
        </div>

        {/* Heading */}
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-black text-white leading-none tracking-tight uppercase mb-6">
          {t('about_page_title')} <span className="text-[#F57F25]">{t('about_page_title_accent')}</span><br className="hidden md:block" /> {t('about_page_title_2')}
        </h1>

        {/* Subheading */}
        <p className="text-white/70 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
          {t('about_page_sub')}
        </p>
      </div>
    </section>
  );
}
